import { computed, reactive } from 'vue';
import type { MapInfo, MapInfoConfig } from '../models';

export const createMapInfo = (config: MapInfoConfig): MapInfo => {
  return {
    layerId: config.layerId,
    layerType: config.layerType,
    title: config.title,
    subtitle: config.subtitle,
    values: config.values,
    colorBar: config.colorBar,
    enabled: config.enabled
  };
};

export const useMapInfo = (mapInfo: MapInfo) => {
  const reactiveMapInfo = reactive(mapInfo);

  const title = computed({ get: () => reactiveMapInfo.title, set: (val) => (reactiveMapInfo.title = val) });
  const subtitle = computed({ get: () => reactiveMapInfo.subtitle, set: (val) => (reactiveMapInfo.subtitle = val) });
  const colorBar = computed({ get: () => reactiveMapInfo.colorBar, set: (val) => (reactiveMapInfo.colorBar = val) });
  const enabled = computed({ get: () => reactiveMapInfo.enabled, set: (val) => (reactiveMapInfo.enabled = val) });
  const values = computed(() => reactiveMapInfo.values);
  const layerType = computed(() => reactiveMapInfo.layerType);
  const layerId = computed(() => reactiveMapInfo.layerId);

  const colorBarGradient = computed(() => {
    if (!colorBar.value) return undefined;

    const params = ['90deg'];

    values.value.forEach((value) => {
      params.push(`${value.color} ${value.percent}%`);
    });

    return `linear-gradient(${params.join(', ')})`;
  });

  return {
    reactiveMapInfo,
    title,
    subtitle,
    colorBar,
    values,
    layerType,
    layerId,
    enabled,
    colorBarGradient
  };
};
